import { createUseStyles } from 'react-jss';
import { base } from '../../css/vars';

export default createUseStyles({
  accentStripColors: {
    '& > *:not(:last-child)': {
      marginBottom: base(),
    },
  },
});
